<template>
  <v-dialog 
  :value="value" 
  @input="$emit('input')" 
  transition="fade-transition" 
    persistent
  scrollable 
  fullscreen>
    <v-card>
      <v-card-title class="card-title-background">
        Edit Content Storyboard
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>close</v-icon>
          </v-btn>
      </v-card-title>
      <v-card-text style="background: #cccccc">
        <creator-concept-form mode="edit" :editData="editData" :value="value" @updatedContentScript="handleUpdatedContentScript" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import CreatorConceptForm from '../CreatorConceptForm/Form';
import utils from '@/utils'
export default {
  name: 'ViewModalDialog',
  components: {
    CreatorConceptForm
  },
  props: {
    value: Boolean,
    data: Object
  },
  data () {
    return {
      utils: utils.func,
      editData: {}
    }
  },
  watch: {
    data(newValue) {
      if (newValue) {
        this.editData = Object.assign({}, this.data)
        // this.currentMode = 'detail'
      }
    }
  },
  methods: {
    handleUpdatedContentScript() {
      // this.close()
      this.$emit('input');
    },
    async close() {
      const result = await this.$swal({
        title: 'Leave without saving changes?',
        text: 'Your changes may not be saved.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Leave',
        cancelButtonText: 'Stay'
      })
      if (!result.value) {
        return
      }
      this.$emit('input');
    }
  }
}
</script>
<style>
  .tiktok-stats .v-data-table__wrapper {
    border-bottom: 1px solid #e0e0e0;
  }
</style>
<style scoped>
  .card-title-background {
    background-color: #3F3FFF;
  }
  label {
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// ViewModalDialog.vue?411ac0ae